export const SHOW_ALL_ZONES_BUTTON_CONTAINER_CLASS =
	"interactive-products-zones-button-container";

	export const SHOW_ALL_ZONES_BUTTON_CONTAINER_CLASS_SELECTOR = `.${SHOW_ALL_ZONES_BUTTON_CONTAINER_CLASS}`;

export const SHOW_ALL_ZONES_INNER_BUTTON_CLASS = `${SHOW_ALL_ZONES_BUTTON_CONTAINER_CLASS}__products-show-button`;


export const SHOW_ALL_ZONES_INNER_BUTTON_CLASS_SELECTOR = `.${SHOW_ALL_ZONES_INNER_BUTTON_CLASS}`;